package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.CREATE_MERCHANT_LOCATION
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

/**
 * Request model for creating a merchant location.
 *
 * According to the database schema:
 * - Creates a record in `merchant_locations` table
 * - Creates translation keys for title, what_you_could_get, address on the server side.
 */

@Serializable
data class CreateMerchantLocationRequestModel(
    val merchantId: Long,
    val businessCategoryId: Long,
    val storeName: String,
    val storeAddress: String,
    val cityId: Long,
    val storePhoneNumber: String,
    val dialCode: String,
    val packaging: String = "",
    val additionalPickupInstructions: String = "",
    val surpriseBagContainsBuffetFood: Boolean = false,
    val latitude: Double,
    val longitude: Double,
    /** Root-level products (name + grams) for the location's catalog. */
    val products: List<com.example.mystybag.sharedmodels.project.responseModels.merchant.LocationProductInput> = emptyList(),
    val coverPhotoUrl: String,
    val menuPhotoUrls: List<String> = emptyList()
) : BaseRequestModel(api = CREATE_MERCHANT_LOCATION)
